import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "584224272531"; // formato internacional sin +

export const PAGO_MOVIL = {
  rif: "J-504862827",
  telefono: "0414 241 2639",
  banco: "Banco Provincial (0108)",
  email: "jca.garajedisimil@gmail.com",
};

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Reintenta 1 vez ante error de red o timeout (conexiones lentas / inestables)
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config;
    const isNetworkOrTimeout =
      error.code === "ECONNABORTED" || !error.response;
    const isRetryable = config && ["get"].includes((config.method || "").toLowerCase());
    if (isNetworkOrTimeout && isRetryable && !config.__retried) {
      config.__retried = true;
      await new Promise((r) => setTimeout(r, 800));
      return api(config);
    }
    return Promise.reject(error);
  }
);

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

export const waLink = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const isConsult = (b) => (b.category === "importada" && (b.product_type || "cerveza") === "cerveza") || !(Number(b.price) > 0);

export const consultPriceUrl = (names) =>
  waLink(`¡Hola Ciudad Garaje! Quiero consultar el precio de:\n${names.map((n) => `• ${n}`).join("\n")}`);


export const CATEGORIES = [
  { value: "todas", label: "Todas" },
  { value: "artesanal", label: "Artesanal" },
  { value: "importada", label: "Importada" },
  { value: "nacional", label: "Nacional" },
];

export const PRODUCT_TYPES = [
  { value: "todos", label: "Todo" },
  { value: "cerveza", label: "Cerveza" },
  { value: "boutique", label: "Boutique" },
];

export const TYPE_LABEL = { cerveza: "Cerveza", boutique: "Boutique" };
